'use strict';

(function() {
	angular.module('onboarding.common')
		.directive('cobWelcomePage', cobWelcomePage);

	cobWelcomePage.$inject = [
		'$rootScope', '$state', '$stateParams', '$log', '$timeout', '$location', 'subjectObserverMessagesService', 'observerService',
		'sessionService'
	];

	var $rootScope,
		$state,
		$stateParams,
		$log,
		$timeout,
		$location,
		subjectObserverMessagesService,
		observerService,
		sessionService,
		subjectMessages,
		observerMessages,
		data;

	function cobWelcomePage(_$rootScope_,
		_$state_,
		_$stateParams_,
		_$log_,
		_$timeout_,
		_$location_,
		_subjectObserverMessagesService_,
		_observerService_,
		_sessionService_) {
		$log = _$log_;
		$timeout = _$timeout_;
		$location = _$location_;
		$state = _$state_;
		$stateParams = _$stateParams_;
		$rootScope = _$rootScope_;
		subjectObserverMessagesService = _subjectObserverMessagesService_;
		observerService = _observerService_;
		sessionService = _sessionService_;

		return {
			restrict: 'E',
			scope: {},
			replace: true,
			templateUrl: '/app/common/welcome/welcomePage.html',
			link: linkFunction
		};
	}

	function linkFunction(scope) {

		activate();

		function activate() {
			scope.$state = $state;
			subjectMessages = subjectObserverMessagesService.getSubjectMessages();
			observerMessages = subjectObserverMessagesService.getObserverMessages();

			scope.forgotUsername = forgotUsername;
			scope.forgotPassword = forgotPassword;
			scope.clearModalMessage = clearModalMessage;
			scope.$on('$locationChangeStart', onLocationChange);

			scope.m = {
				errors: [],
				date: new Date(),
				modalMessage: $stateParams.modalMessage,
				modalTitle: $stateParams.modalTitle,
				modalIsError: $stateParams.modalIsError,
				domain: '',
				welcomeMessageDisabled: false
			};

			$location.url($location.path());

			switch ($state.current.name) {
			case 'dot':
				document.title = 'Carrier Registration';
				scope.prevState = 'dotNumberSection';
				break;
			case 'username':
				document.title = 'Forgot Username';
				break;
			case 'password':
				document.title = 'Forgot Password';
				break;
			case 'resetpassword':
				document.title = 'Reset Password';
				break;
			case 'intrastate':
				document.title = 'Intrastate';
				scope.prevState = 'intrastateSection';
				break;
			case 'canadian':
				document.title = 'Canadian Carrier';
				scope.prevState = 'canadianSection';
				break;
			case 'selectcarrier':
				document.title = 'Select Carrier';
				break;
			case 'confirmCompany':
				document.title = 'Confirm Company';
				break;
			default:
				document.title = 'Login';
				break;
			}

			scope.setActiveSlide = setActiveSlide;

			data = {
				dotNumber: '',
				state: '',
				intrastateNumber: '',
				province: '',
				nationalSafetyNumber: '',
				docketNumber: '',
				carrierList: [],
				numberText: '',
				searchNumber: ''
			};

			registerObserverHandlers();
		}

		function onLocationChange() {
			$rootScope.lastLocation = $rootScope.actualLocation;
			$rootScope.actualLocation = $location.path();
		}

		function registerObserverHandlers() {
			if (sessionService.getDomain()) {
				$timeout(function() {
					onDoaminDataLoad();
				},
				1);
			}

			observerService.registerHandlers(scope,
				[
					{ message: observerMessages.COB_OBSERVER_DOMAIN_DATA_LOADED, handler: onDoaminDataLoad },
					{ message: observerMessages.COB_OBSERVER_CHANGE_WELCOME_VIEW, handler: changeView }
				]);
		}

		function changeView(obj) {
			if (typeof obj.setActiveSlide == 'string') {
				scope.m.activeSlide = obj.setActiveSlide;
				$rootScope.lastLocation = $location.path();
				if (obj.setActiveSlide == 'back') {
					obj.setActiveSlide = scope.prevState;
				}

				switch (obj.setActiveSlide) {
				case 'dotNumberSection':
					$state.go('dot', null, { notify: false });
					document.title = 'Carrier Registration';
					scope.prevState = obj.setActiveSlide;
					break;
				case 'forgotUsernameSection':
					$state.go('username', null, { notify: false });
					document.title = 'Forgot Username';
					break;
				case 'forgotPasswordSection':
					$state.go('password', null, { notify: false });
					document.title = 'Forgot Password';
					break;
				case 'resetPasswordSection':
					$state.go('resetpassword', null, { notify: false });
					document.title = 'Reset Password';
					break;
				case 'intrastateSection':
					$state.go('intrastate', null, { notify: false });
					document.title = 'Intrastate';
					scope.prevState = obj.setActiveSlide;
					break;
				case 'canadianSection':
					$state.go('canadian', null, { notify: false });
					document.title = 'Canadian Carrier';
					scope.prevState = obj.setActiveSlide;
					break;
				case 'multipleCarriersSection':
					$state.go('selectcarrier', null, { notify: false });
					document.title = 'Select Carrier';
					break;
				case 'confirmCompanySection':
					$state.go('confirmCompany', null, { notify: false });
					document.title = 'Confirm Company';
					break;
				default:
					$state.go('login', null, { notify: false });
					document.title = 'Login';
					break;
				}
			}
			if (obj.modalMessage) {
				scope.m.modalMessage = obj.modalMessage;
			} else {
				scope.m.modalMessage = '';
			}
			if (obj.modalTitle) {
				scope.m.modalTitle = obj.modalTitle;
			} else {
				scope.m.modalTitle = '';
			}
			if (obj.dotNumber) {
				data.dotNumber = obj.dotNumber;
			}
			if (obj.state) {
				data.state = obj.state;
			}
			if (obj.intrastateNumber) {
				data.intrastateNumber = obj.intrastateNumber;
			}
			if (obj.province) {
				data.province = obj.province;
			}
			if (obj.nationalSafetyNumber) {
				data.nationalSafetyNumber = obj.nationalSafetyNumber;
			}
			if (obj.docketNumber) {
				data.docketNumber = obj.docketNumber;
			}
			if (obj.carrierList) {
				data.carrierList = obj.carrierList;
				scope.carrierList = data.carrierList;
			}
			if (obj.numberText) {
				data.numberText = obj.numberText;
				scope.numberText = data.numberText;
			}
			if (obj.searchNumber) {
				data.searchNumber = obj.searchNumber;
				scope.searchNumber = data.searchNumber;
			}
		}

		function setActiveSlide(slide) {

			scope.m.activeSlide = slide;

			observerService.sendMessageToSubject(scope,
				subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_CHANGE_WELCOME_VIEW,
				{
					setActiveSlide: slide,
					modalMessage: '',
					modalTitle: ''
				});

		}

		function onDoaminDataLoad() {
			scope.m.domain = sessionService.getDomain();
			scope.m.logoURL = sessionService.getBrokerLogoURL();
			var brokerInfo = sessionService.getBrokerBranding();
			scope.m.name = brokerInfo.brokerName;
			scope.m.welcomeMessageDisabled = brokerInfo.welcomeMessageDisabled;
		}

		function forgotUsername() {
			setActiveSlide('forgotUsernameSection');
		}

		function forgotPassword() {
			setActiveSlide('forgotPasswordSection');
		}

		function clearModalMessage() {
			scope.m.modalMessage = '';
			scope.m.modalTitle = '';
			scope.m.modalIsError = false;
		}
	}

})();
